import { z } from 'zod';
import { localDate } from '@itvisits/shared';
import type { DashboardParams } from '../../api/dashboard';

/** URL search for /dashboard. Absent dates mean "current Pacific month" (the API default). */
export const dashboardSearchSchema = z.object({
  from: z.iso.date().optional().catch(undefined),
  to: z.iso.date().optional().catch(undefined),
  clusterId: z.coerce.number().int().positive().optional().catch(undefined),
  facilityId: z.coerce.number().int().positive().optional().catch(undefined),
  technicianId: z.coerce.number().int().positive().optional().catch(undefined),
});
export type DashboardSearch = z.infer<typeof dashboardSearchSchema>;

export function toParams(s: DashboardSearch): DashboardParams {
  return {
    from: s.from,
    to: s.to,
    clusterId: s.clusterId,
    facilityId: s.facilityId,
    technicianId: s.technicianId,
  };
}

/** Omit unset keys so the URL stays short. */
export function toSearch(s: DashboardSearch): DashboardSearch {
  const out: DashboardSearch = {};
  for (const [k, v] of Object.entries(s)) {
    if (v !== undefined && v !== '') (out as Record<string, unknown>)[k] = v;
  }
  return out;
}

/** First day of the current Pacific month and today, for the date inputs' placeholders. */
export function currentMonthRange(now = new Date()): { from: string; to: string } {
  const today = localDate(now);
  return { from: `${today.slice(0, 7)}-01`, to: today };
}
